import React, { Component } from 'react';
import { getUser} from '../Actions/UserActions';

import { connect } from 'react-redux';

import NavBar2 from "./NavBar2";
import SiteFoot from "../Components/SiteFoot";

class iplitigation extends Component {
    constructor(props) {
        super(props);
        this.state = {
            email: '',
            width: window.innerWidth,
            password: '',
            error: ''
        };
    }
    componentWillMount() {
        window.addEventListener('resize', this.handleWindowSizeChange);
    }

// make sure to remove the listener
// when the component is not mounted anymore
    componentWillUnmount() {
        window.removeEventListener('resize', this.handleWindowSizeChange);
    }
    handleWindowSizeChange = () => {
        this.setState({ width: window.innerWidth });
    };











    render() {


        var lang
        if(this.props.lang==="zh"||this.props.lang==="zh-hk"||this.props.lang==="zh-cn"||this.props.lang==="zh-sg"||this.props.lang==="zh-tw"|| this.props.lang==="zh-HK"||this.props.lang==="zh-CN"||this.props.lang==="zh-SG"||this.props.lang==="zh-TW"){
            lang= "zh"
        }else{
            lang="en"
        }


        return (
            <div style={{ height: "100%",}}>



            <div  style={{backgroundColor:"white", width: "100%", display: "flex", top: "0", position:"fixed", left: "0px",
                zIndex: "500",  borderStyle: "solid",  borderColor: "FireBrick", borderWidth: "0px 0px 2px 0px"}}>


                <NavBar2/>




                ​



                ​











            </div>
            {this.state.width<500 &&<div style={{height: "16vw",}} ></div>}
            {this.state.width>=500 &&<div style={{height: "10vw", }} ></div>}

            <div>
                <div style={{width: "90%", margin: "auto", display: "block", padding: "0px", fontFamily:"Open Sans, sans-serif"}} >
                    {lang==="en" &&  <div style={{width: "50%", maxWidth:"50%", verticalAlign:"top", minWidth:"20em",display: "inline-block", backgroundColor:"white", padding: "30px",}} >

                        <span style={{fontSize: "1.5em", fontWeight: "bold"}}>Intellectual Property Litigation</span><p/>
                        <span style={{fontSize: ".8em"}}>The Morrow Firm has deep experience handling intellectual property litigation from pre-litigation counseling to trial.</span><p/>

                        <span style={{fontSize: ".8em"}}>Representative experience:</span><p/>
                        ​

                        <ul>
                            <span style={{fontSize: ".8em"}}><li>Represented d.bleu.dazzled in a trade dress infringement and fraud action against Khloe Kardashian and Good American LLC and defeated Ms. Kardashian and Good American's Anti-SLAPP motion. See  <a href="https://www.thefashionlaw.com/court-shoots-down-khloe-kardashian-good-americans-anti-slapp-motion-in-dbleudazzled-bodysuit-case/" target="_blank" rel="noopener noreferrer">The Fashion Law</a>, Court Shoots Down Khloe Kardashian, Good American’s anti-SLAPP Motion in Dbleudazzled Bodysuit Case.</li></span><br/>
                            <span style={{fontSize: ".8em"}}><li>Served as trial counsel for T-Mobile in a three-week jury trial in Seattle, winning verdicts on misappropriation of trade secrets and breach of contract claims against Huawei Devices USA. See <a href="https://www.seattletimes.com/business/technology/july-awards-t-mobile-48m-in-trade-secrets-case-against-huawei/" target="_blank" rel="noopener noreferrer"> Seattle Times</a>, Jury awards T-Mobile $4.8M in trade-secrets case against Huawei; <a href="https://www.nytimes.com/2014/09/06/business/t-mobile-accuses-huawei-of-theft-from-laboratory.html" rel="noopener noreferrer"> New York Times</a>, T-Mobile Accuses Huawei of Theft From Laboratory.</li></span><br/>
                            <span style={{fontSize: ".8em"}}><li>Obtained over $740 million for TiVo in patent infringement settlements. See <a href="https://www.nytimes.com/2012/09/25/business/media/verizon-to-pay-250-million-to-tivo-in-patent-settlement.html" target="_blank" rel="noopener noreferrer">New York Times</a>, Verizon to Pay TiVo $250 Million Settlement; <a href="https://www.usatoday.com/story/money/business/2013/06/07/tivo-settles-cisco-motorola-time-warner/2399849/" >USA Today</a>, TiVo settles with Cisco, Motorola and Time Warner.</li></span><br/>
                            <span style={{fontSize: ".8em"}}><li>Represented ClearOne in a patent infringement action relating to installed audio-conferencing technology against Shure and obtained a preliminary injunction against Shure. See <a href="https://www.commercialintegrator.com/av/audio/microphones/clearone-lawsuit-beamforming-microphone-array/" target="_blank" rel="noopener noreferrer"> Commercial Integrator</a>, ClearOne and Shure: History of Their Legal Dispute Over Beamforming Microphone Arrays; <a href="https://www.bloomberg.com/press-releases/2019-08-06/clearone-wins-preliminary-injunction-against-shure-s-mxa910-ceiling-array-microphone" target="_blank" rel="noopener noreferrer">Bloomberg</a>, ClearOne Wins Preliminary Injunction Against Shure’s MXA910 Ceiling Array Microphone.</li></span><br/>

                            <span style={{fontSize: ".8em"}}><li>Represented Peloton in a patent infringement action against Flywheel relating to Peloton’s category-creating bike. See <a href="https://www.wsj.com/articles/bike-maker-peloton-claims-flywheel-copied-its-technology-1536776620" target="_blank" rel="noopener noreferrer"> Wall Street Journal</a>, Bike Maker Peloton Claims Flywheel Copied Its Technology.</li></span><br/>
                            <span style={{fontSize: ".8em"}}><li>Represented T-Mobile in patent infringement actions involving alleged standard essential patents relating to various cellular communication standards.</li></span><br/>
                            <span style={{fontSize: ".8em"}}><li>Defended BlackBerry in patent infringement actions and obtained favorable settlements.</li></span><br/>
                            <span style={{fontSize: ".8em"}}><li>Represented Core Wireless in patent infringement actions against LG and obtained favorable verdicts as to all asserted claims and full damages sought.</li></span><br/>
                            <span style={{fontSize: ".8em"}}><li>Represented an e-commerce company in a trademark infringement and unfair competition (UCL) lawsuit. </li></span><br/>
                            <span style={{fontSize: ".8em"}}><li>Represented various software and hardware companies in patent infringement lawsuits.  </li></span><br/>
                            <span style={{fontSize: ".8em"}}><li>Represented a Chinese businessman accused of trade secrets theft.</li></span><br/>
                            <span style={{fontSize: ".8em"}}><li>Defended a Hong Kong-based technology company in a trade secrets case.</li></span><br/>


                        </ul>
            </div>}
                    {lang==="zh" &&  <div style={{width: "50%", maxWidth:"50%", verticalAlign:"top", minWidth:"20em",display: "inline-block", backgroundColor:"white", padding: "30px",}} >

                        <span style={{fontSize: "1.5em", fontWeight: "bold"}}> 知识产权诉讼与纠纷</span><p/>
                        <span style={{fontSize: ".8em"}}>沫若律师事务所在处理知识产权诉讼方面，从诉前咨询到最终庭审都拥有丰富的经验。</span><p/>

                        <span style={{fontSize: ".8em"}}>代表经验：</span><p/>
                        ​

                        <ul>
                            <span style={{fontSize: ".8em"}}><li> 代表d.bleu.dazzled向科勒·卡戴珊和Good American提起商业外观侵权和欺诈诉讼，并成功的完全击败卡戴珊女士和Good American的反对公共参与的战略诉讼（Antti-SLAPP）动议。参见<a href="https://www.thefashionlaw.com/court-shoots-down-khloe-kardashian-good-americans-anti-slapp-motion-in-dbleudazzled-bodysuit-case/" target="_blank" rel="noopener noreferrer">The Fashion Law</a>报道，Court Shoots Down Khloe Kardashian, Good American’s anti-SLAPP Motion in Dbleudazzled Bodysuit Case。</li></span><br/>
                            <span style={{fontSize: ".8em"}}><li>在西雅图进行为期三周的陪审团审判中担任T-Mobile的出庭律师，赢得了对华为美国终端公司盗用商业机密和违反合同索赔的判决。参见<a href="https://www.seattletimes.com/business/technology/july-awards-t-mobile-48m-in-trade-secrets-case-against-huawei/" target="_blank" rel="noopener noreferrer">西雅图时报报道</a>，Jury awards T-Mobile $4.8M in trade-secrets case against Huawei；<a href="https://www.nytimes.com/2014/09/06/business/t-mobile-accuses-huawei-of-theft-from-laboratory.html" target="_blank" rel="noopener noreferrer">纽约时报报道</a>，T-Mobile Accuses Huawei of Theft From Laboratory。</li></span><br/>
                            <span style={{fontSize: ".8em"}}><li>为TiVo通过专利侵权诉讼获得总额超过7.4亿美元的庭外和解。参见<a href="https://www.nytimes.com/2012/09/25/business/media/verizon-to-pay-250-million-to-tivo-in-patent-settlement.html" target="_blank" rel="noopener noreferrer">纽约时报报道</a>，Verizon to Pay TiVo $250 Million Settlement;<a href="https://www.usatoday.com/story/money/business/2013/06/07/tivo-settles-cisco-motorola-time-warner/2399849/" >今日美国报道</a>，TiVo settles with Cisco, Motorola and Time Warner。</li></span><br/>
                            <span style={{fontSize: ".8em"}}><li>代表ClearOne向Shure提起与音频会议技术相关的专利侵权诉讼并赢得针对Shure的初步禁令。参见<a href="https://www.commercialintegrator.com/av/audio/microphones/clearone-lawsuit-beamforming-microphone-array/" target="_blank" rel="noopener noreferrer"> Commercial Integrator</a>报道，ClearOne and Shure: History of Their Legal Dispute Over Beamforming Microphone Arrays；<a href="https://www.bloomberg.com/press-releases/2019-08-06/clearone-wins-preliminary-injunction-against-shure-s-mxa910-ceiling-array-microphone" target="_blank" rel="noopener noreferrer">Bloomberg</a>报道，ClearOne Wins Preliminary Injunction Against Shure’s MXA910 Ceiling Array Microphone。</li></span><br/>
                            <span style={{fontSize: ".8em"}}><li>代表Peloton对Flywheel进行专利侵权诉讼。参见<a href="https://www.wsj.com/articles/bike-maker-peloton-claims-flywheel-copied-its-technology-1536776620" target="_blank" rel="noopener noreferrer">华尔街日报</a>，Bike Maker Peloton Claims Flywheel Copied Its Technology。</li></span><br/>
                            <span style={{fontSize: ".8em"}}><li>代表T-Mobile处理涉及蜂窝通信标准的标准必要专利的专利侵权诉讼。</li></span><br/>
                            <span style={{fontSize: ".8em"}}><li>在专利侵权诉讼中为黑莓公司辩护并获得了有利的庭外和解。</li></span><br/>
                            <span style={{fontSize: ".8em"}}><li>代表Core Wireless处理针对LG的专利侵权诉讼，并就所有索赔和所要求的全部赔偿金获得了有利判决。</li></span><br/>
                            <span style={{fontSize: ".8em"}}><li>代表受到窃取商业秘密指控的中国商人。</li></span><br/>
                            <span style={{fontSize: ".8em"}}><li>在商业秘密案件中为一家香港科技公司辩护。</li></span><br/>
                        </ul>
                    </div>}

            <div style={{width: "49%", maxWidth:"50%",  height:"100%", verticalAlign:"top", minWidth:"20em",display: "inline-block",  padding: "5px", top:"0px", }} ><img  alt="​Intellectual Property Litigation" style={{top:"0px", width: "100%"}} src="https://firebasestorage.googleapis.com/v0/b/absite-15edf.appspot.com/o/ip.jpg?alt=media&token=8ad4fd3e-2186-42a9-959d-428c3be2fa18"/>

            </div>
            </div>
            </div>
        <div  style={{backgroundColor:"white", width: "100%", display: "flex", bottom: "0px", position:"fixed", left: "0px"}}>j</div>


            <SiteFoot lang={lang}/>
        </div>


    );
    }
}

function mapStateToProps(state, ownProps) {
    return { user: state.user, admin: state.admin, lang: state.lang  };
}

export default connect(mapStateToProps, { getUser })(iplitigation);



// WEBPACK FOOTER //
// ./src/Containers/iplitigation.js